export const MARQUEE_ITEMS = [
  'Verified Developments',
  'Lekki',
  'Ikoyi',
  'Victoria Island',
  'Premium Investments',
  'Residential Projects',
  'Ikeja',
  'Winchester Construction',
  'Plot Kapital Development',
  'Property Portfolio',
  'Investment Opportunities',
  'Lagos Real Estate',
  'Shortlet & Long-Stay',
  'Luxury Residences',
];
